export default "__VITE_ASSET__BhRtJ6Oj__"